const product_single_buy_now_bottom = document.querySelector('.js_product_single_buy_now_bottom')
const product_single_buy_now_btn = document.querySelector('.js_product_single_buy_now_btn');
const retailerLinks = document.querySelectorAll('.js_product_retailer_link');
// const product_single_buy_now_top = document.querySelector('.js_product_single_buy_now_top')

if (product_single_buy_now_btn) {
  product_single_buy_now_btn.addEventListener('click', function () {

    // Get data attributes from the button
    const productId = this.getAttribute('data-product-id');
    const productTitle = this.getAttribute('data-product-title');
    const productCategory = this.getAttribute('data-product-category');
    const linkUrl = this.getAttribute('data-link-url');

    const gtmEvent = {
      trigger: 'click CTA buy now',
      event_id: '1.9',
      event: 'cta_buy_now',
      event_campaign: 'general',
      content_type: 'button',
      content_id: productId,
      product_title: productTitle,
      category: productCategory,
      linkUrl: linkUrl
    };

    dataLayer.push(gtmEvent);
  });
}

retailerLinks.forEach(link => {
  link.addEventListener('click', function (e) {
    const productTitle = product_single_buy_now_btn.getAttribute('data-product-title');
    const retailer = this.getAttribute('data-retailer');
    const linkUrl = this.getAttribute('href');

    const gtmEvent = {
      trigger: 'buy from retailers',
      event_id: '1.11',
      event: 'retailer_link',
      link_url: linkUrl,
      event_campaign: 'general',
      content_id: productTitle,
      content_type: 'retailer button',
      category: 'products',
      retailer: retailer,
      market: window.getMarketFromUrl(),
    };

    // Push the GTM event to dataLayer
    dataLayer.push(gtmEvent);
  });
});


if (product_single_buy_now_bottom) {
// if (product_single_buy_now_bottom && product_single_buy_now_top) {

  // let latestKnownScrollY = 0

  // const handleScroll = (scrollValue) => {
  //   if (scrollValue > 700) {
  //     product_single_buy_now_bottom.classList.add('show')
  //     product_single_buy_now_top.classList.remove('show')
  //   }
  //   else {
  //     product_single_buy_now_bottom.classList.remove('show')
  //     product_single_buy_now_top.classList.add('show')
  //   }
  // }

  // function debounce (method, delay, scrollValue) {
  //   clearTimeout(method._tId)
  //   method._tId = setTimeout(function () {
  //     method(scrollValue)
  //   }, delay)
  // }

  // window.addEventListener('scroll', () => {
  //   latestKnownScrollY = window.scrollY //No IE8
  //   handleScroll(latestKnownScrollY)
  // })

  // debounce(handleScroll, 1400, latestKnownScrollY)

  // Make buy now button visible on every screen -  if it is off-screen make it
  // fixed
  // const buyNowTopPos = product_single_buy_now_top.offsetTop
  // const screenHeight = screen.height
  // if (screenHeight < buyNowTopPos) {
  //   product_single_buy_now_top.classList.add('fixed')
  // }


  // show buy now, always after a delay
  const showBuyNow = () => {
    setTimeout( () => {
      product_single_buy_now_bottom.classList.add('show')
    }, 1400)
  }

  showBuyNow()

}
